export default {
    namespaced: true,
    state: {
        products: [],
    },
    getters: {
        items(state) {
            return state.products;
        },
        totalQty(state) {
            let qty = 0;
            state.products.forEach((item) => {
                qty += Number(item.qty);
            });
            return qty;
        },
        totalPrice(state) {
            let price = 0;
            state.products.forEach((item) => {
                price += item.subTotal;
            });
            return price;
        },
    },
    mutations: {
        INIT_PRODUCTS(state, items) {
            state.products = items;
        },
        CLEAR_PRODUCTS(state) {
            state.products = [];
        },
        ADD_PRODUCT(state, item) {
            let cat = {
                id: item.id,
                name: item.name,
                imei: item.imei,
                sNumber: item.sNumber,
                sku: item.sku,
                qty: 0,
                discount: 0,
                price: item.price,
                subTotal: 0,
                data: item,
            };
            if (item.variants && item.variants.length > 0) {
                cat.name = item.name + "(" + item.variants[0]["variant"] + ")";
                cat.price =
                    Number(cat.price) + Number(item.variants[0]["price"]);
            }
            state.products.map((product) => {
                if (item.id === product.id && cat.name === product.name) {
                    cat = product;
                    state.products.splice(state.products.indexOf(cat), 1);
                }
            });
            cat.qty++;
            cat.subTotal = cat.qty * cat.price;
            state.products.push(cat);
        },

        REMOVE_PRODUCT(state, product) {
            state.products.splice(state.products.indexOf(product), 1);
        },
    },
    actions: {
        init({ commit }, payload) {
            commit("INIT_PRODUCTS", payload);
        },
        clear({ commit }) {
            commit("CLEAR_PRODUCTS");
        },
        add({ commit }, payload) {
            commit("ADD_PRODUCT", payload);
        },
        remove({ commit }, payload) {
            commit("REMOVE_PRODUCT", payload);
        },
    },
};
